export default __webpack_public_path__ + "static/media/czk.c9ef36c7.png";